import { Component } from '@angular/core';

/**
 * Generated class for the SportsIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sports-icon',
  templateUrl: 'sports-icon.html'
})
export class SportsIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/sports-icon/sports-icon.ts